<template>
  <XCard class="py-6 px-4 mb-24">
    <div class="py-2 px-3 text-center mb-2">
      <div class="font-semibold text-lg">
        {{ name }}
      </div>
    </div>

    <div class="relative">
      <XLazyMedia
        :media="settings.channels.cta[0]"
        alt="Image"
        :mediaClass="[$style.raffle, { [$style.locked]: locked }]"
        @mediaLoaded="onMediaLoaded"
        @click.native="checkLuck"
      />

      <div
        v-if="errorMessage"
        class="mt-3 text-danger-50"
      >
        {{ errorMessage }}
      </div>

      <div
        v-show="loading"
        class="absolute pin-t pin-b pin-l pin-r flex items-center justify-center text-grey-30 text-xl"
        :class="$style['white-smoke']"
      >
        <img
          v-if="settings.channels.loading.length > 0"
          :src="settings.channels.loading[0]"
        >

        <XSpinner
          v-else
          class="text-4xl"
        />
      </div>

      <div
        v-if="locked"
        class="absolute pin-t pin-b pin-l pin-r flex items-center justify-center text-grey-30 text-xl"
        :class="$style['white-smoke']"
      >
        <span
          v-if="participationIsLocked"
          class="text-center font-bold"
        >
          {{ $t('event.timeline.raffle.statuses.thankYou') }}
        </span>

        <span
          v-else-if="noAvailableItemsToGive"
          class="text-center font-bold"
        >
          {{ $t('event.timeline.raffle.statuses.noGift') }}
        </span>
      </div>
    </div>
  </XCard>
</template>

<script>
import gql from 'graphql-tag'
import { mapState } from 'vuex'

export default {
  props: {
    id: {
      type: String
    },
    name: {
      type: String
    },
    settings: {
      type: Object
    },
    reactionCount: {
      type: Number
    }
  },

  data () {
    return {
      loading: false,
      mediaLoaded: false,
      errorMessage: ''
    }
  },

  computed: {
    ...mapState({
      attendeeId: state => state.routeParameters.attendee.id
    }),

    participationIsLocked () {
      return this.mediaLoaded &&
             this.reactionCount >= this.settings.maxParticipations
    },

    noAvailableItemsToGive () {
      return !this.settings.hasAvailableItemsToGive
    },

    locked () {
      return this.participationIsLocked || this.noAvailableItemsToGive
    }
  },

  methods: {
    checkLuck () {
      if (this.loading && !this.mediaLoaded) {
        return
      }

      this.loading = true
      this.errorMessage = ''

      let now = Date.now()

      return this.participate()
        .then(raffleParticipation => {
          let delay = 3000 - (Date.now() - now)
          delay = delay >= 0 ? delay : 0

          if (raffleParticipation) {
            setTimeout(() => {
              this.$emit('addReaction', raffleParticipation)
              this.loading = false
            }, delay)
          }
        })
        .catch(() => {
          this.errorMessage = this.$t('common.notifications.messages.requestError')
          this.loading = false
        })
    },

    onMediaLoaded () {
      this.mediaLoaded = true
    },

    participate () {
      return this.$apollo
        .mutate({
          mutation: gql`
            mutation RaffleParticipation($attendeeId: Uuid!, $actionId: Uuid!) {
              attendee(attendeeId: $attendeeId) {
                raffleParticipation(actionId: $actionId) {
                  id
                  type
                  url
                  createdAt
                  data
                }
              }
            }
          `,
          variables: {
            attendeeId: this.attendeeId,
            actionId: this.id
          }
        })
        .then(result => result.data.attendee.raffleParticipation)
    }
  }
}
</script>

<style
  lang="scss"
  module
>
.white-smoke {
  background: rgba(255, 255, 255, .7);
}

.raffle {
  width: auto !important;
  cursor: pointer;

  &.locked {
    filter: blur(2px);
  }
}
</style>
